// tslint:disable:max-line-length
import * as React from "react";
import { iconStyle } from './icon.style';
interface IProps {
  style?: React.CSSProperties;
}
export const HelpIcon: React.FC<IProps> = (props) =><svg id="icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={{...iconStyle, ...props.style}}>
  <path d="M12,0C5.38,0,0,5.38,0,12s5.38,12,12,12,12-5.38,12-12S18.62,0,12,0ZM12,22c-5.51,0-10-4.49-10-10S6.49,2,12,2s10,4.49,10,10-4.49,10-10,10ZM14.5,18c0,.55-.45,1-1,1h-1.22c-.62,0-1.19-.28-1.58-.77s-.51-1.11-.37-1.72l1.38-5.52h-1.22c-.55,0-1-.45-1-1s.45-1,1-1h1.86c.47,0,.9.21,1.18.58.29.37.39.84.27,1.29l-1.53,6.14h1.22c.55,0,1,.45,1,1ZM10.5,6.5c0-.83.67-1.5,1.5-1.5s1.5.67,1.5,1.5-.67,1.5-1.5,1.5-1.5-.67-1.5-1.5Z"/>
</svg>


// WEBPACK FOOTER //
// ./src/icons/Help.tsx